export const locale = {
  lang: 'en',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'This is a Focus Area process',
        'NO-ENCU':'You do not currently have an assigned survey process',
        'ENC-AUTO':'Authorized Survey',
        'ENC-CORRECI':'The survey was sent for correction',
        'MODAL_NO_COLAB_EMPRE':'You have not yet uploaded your contributor base, are you sure to continue?',
      },
      'STATUS-ENCUESTA':{
        '1': 'In process',
        '2':' Evaluate',
        '3':' Authorized',
        '5': 'Correct',

      },
      'LISTA': {
        'TAB': 'List of participants',
        'BUSCAR': {
          'INFO': 'You can search for one or more participants from the list by typing the name below',
          'PLACEHOLDER': 'Find a participant'
        },
        'AGREGAR': {
          'BOTON': 'Add a participant'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Full name',
            'EMAIL': 'Email',
            'ACCIONES': 'Available Actions'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Add a participant to the list',
          'EDITAR': 'Edit this participant data'
        }
      },
      'MODALES':{
        'CREARENC': 'Enter the Name of the Survey',
        'CORRECTO': 'It was added correctly ',
        'DELETE': 'You really want to eliminate',
        'COMDELETE': 'Correctly removed',
        'RSPSI': 'YES',
        'RSPNO': 'NO',
        'RSPOK': 'OK',
        'RSPACEPTAR':'Accept',
        'CARGANDOLISTA': 'Retrieving the list of participants, please wait a moment'

      },

      'WIZARD':{
        'CARGANDOF': 'Loading acquired products',
        'SINPRODS': 'You have not acquired this product',
        'CREARENC': 'Create survey',
        'DONE': 'Application year: ',
        'TITULO': 'WELCOME TO FOCUS AREA',
        'TFOCUS': 'SURVEY´S TO FOCUS AREA',
        'DELETE': 'Delete',
        'EDIT': 'Edit',
        'VERIPRE':'Check questions',
        'AVANCE':'Advance',
        'TITUVERI':'Verification of questions',
        'TITUTABTEM':'Questions about templates',
        'TITUTABADI':'Customized Questions',
        'TITUTAUTORIZADA':'Authorized Survey',
        'TITUTNOAUTORIZADA':'Disauthorize Survey',
        'TITUTAUTORIZAR':'Authorize Survey',
        'TITUTCORREGIR':'Correct Survey',
      },
      'TABLACAMPOS':{
        'NAME':'Survey name',
        'FECHAI':'Start date',
        'FECHAF':'Target date',
        'AVANCE':'Advance',
        'ESTADO': 'Status',
        'ACCION': 'Actions',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Upload Certified Collaborators'
      },
      'GRUPOS':{
        'NOMBRE_OK': "Se agrego correctamente el nombre",
        'DESCRIPCION_OK': "Se agrego correctamente la descripcion",
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'Open questions',
        'PREGUN':'Questions',
        'PREGUNSUB':'Question',
        'DESCRIP-PREGUN':'Click here to display the question',
        'TITULO-UNAOPC':'One-choice questions',
        'TITULO-MULOPC':'Multiple choice questions',
        'OPC':'Options',
        'OPCSUB':'Option',
        'NO-ADICI':'The survey has no additional questions',
      },
      'IDIOM-NATIVO':{
        'pt':'Portugues',
        'es':'Español',
        'en':'English',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'Selection type of collaborators',
          'INST_1':'Select one of the following options',
          'NUEVA_BASE_COLA':'Upload new collaborator base',
          'BASE_COLAB_EXIS':'Use main contributor base',
          'BTN_SIGUENTE':'Next',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'Selection of contributors',
          'MAT_TITLE_DEMO_SELE':'Selected demographics',
          'ALERT_NOT_DEMO_SELE':'You have not yet selected filters',
          'ALERT_NOT_SELE_COLAB':'No collaborators added',
          'AGREGAR_FILTRO':'Add filter',
          'TH_NOMBRE':'Contributor name',
          'TH_ACCION':'Actions',
          'INTS_SEL_1_O_MAS_COLAB':'*Note: select one or more collaborators',
          'SIN_RESULTADOS':'The current filter selection did not return any results, try changing filters and try again',
          'BTN_REGRESAR':'Return',
          'BTN_AGRE_COLAB':'Add collaborators',
          'BTN_GUAR_COLAB':'Save collaborators',
          'BTN_BORR_COLAB':'Delete collaborators',
          'BTN_ACEPTAR':'Accept',
          'BTN_BUSCAR':'Search',
          'TITULO_MODAL_DEMOGRA':'List of demographics',
          'MAT_TITLE_EXPA_RESULT':'Contributor search results:',
          'MAT_TITLE_EXPA_AGREG':'Aggregate collaborators:',
          'MAT_TITLE_EXPA_DESCRIP':'See collaborators',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'Loading filters',
            'MODAL_BUSCA_COLAB':'Searching for filtered collaborators',
            'MODAL_AGRE_COLAB':'Adding collaborators',
            'MODAL_DELET_COLAB':'Deleting collaborator information',
            'MODAL_SUCCES_AGRE_COLAB':'Collaborators were successfully added',
            'MODAL_GUAR_COLAB':'Saving collaborators',
            'MODAL_CONFIR_BORRAR_COLAB':'Are you sure to delete the contributor?',
            'MODAL_CONFIR_BORRAR_COLABRES':'Are you sure to delete the collaborators?',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'Are you sure to save the added collaborators?',
            'MODAL_SUCCES_GUAR_COLAB':'Collaborators were saved correctly',
            'MODAL_SUCCES_BORRA_COLAB':'Contributor was deleted correctly',
            'MODAL_SUCCES_BORRA_COLABRES':'Contributors were deleted successfully',
            'MODAL_WARNN_NO_SELECT_COLAB':'You have not selected any collaborator yet',
            'BTN_SI':'Yes',
            'BTN_NO':'No',
            'BTN_OK':'Ok',
          },
          'FORMULARIO':{
            'fullName': 'FULL NAME',
            'ownKey': 'EMPLOYEE NUMBER',
            'age': 'YEAR OF BIRTH',
            'surveyKey': 'SURVEY ACCESS KEY',
            'email': 'EMAIL',
            'bossName': 'DIRECT BOSS NAME',
            'bossKey': 'DIRECT BOSS NUMBER',
            'country': 'COUNTRY',
            'location': 'LOCATION',
            'geo_1': 'GEOGRAPHIC LEVEL 1',
            'geo_2': 'GEOGRAPHIC LEVEL 2',
            'geo_3': 'GEOGRAPHIC LEVEL 3',
            'geo_4': 'GEOGRAPHIC LEVEL 4',
            'geo_5': 'GEOGRAPHIC LEVEL 5',
            'geo_6': 'GEOGRAPHIC LEVEL 6',
            'geo_7': 'GEOGRAPHIC LEVEL 7',
            'geo_8': 'GEOGRAPHIC LEVEL 8',
            'geo_9': 'GEOGRAPHIC LEVEL 9',
            'geo_10': 'GEOGRAPHIC LEVEL 10',
            'structure_1': 'STRUCTURAL LEVEL 1',
            'structure_2': 'STRUCTURAL LEVEL 2',
            'structure_3': 'STRUCTURAL LEVEL 3',
            'structure_4': 'STRUCTURAL LEVEL 4',
            'structure_5': 'STRUCTURAL LEVEL 5',
            'structure_6': 'STRUCTURAL LEVEL 6',
            'structure_7': 'STRUCTURAL LEVEL 7',
            'structure_8': 'STRUCTURAL LEVEL 8',
            'structure_9': 'STRUCTURAL LEVEL 9',
            'structure_10': 'STRUCTURAL LEVEL 10',
            'area': 'AREA',
            'bUnit': 'BUSINESS UNIT',
            'enterDate': 'DATE OF ENTRY TO THE COMPANY',
            'antiquity': 'ANTIQUITY',
            'antiquityUS': 'ANTIQUITY US',
            'generation': 'GENERATION',
            'generationUS': 'GENERATION US',
            'ageUS': 'AGE',
            'charge': 'POSITION OR FUNCTION IN THE COMPANY',
            'homologado': 'CHARGE OR FUNCTION APPROVED',
            'homologadoUS': 'CHARGE OR FUNCTION APPROVED US',
            'gender': 'GENDER',
            'genderType': 'TYPE OF GENDER',
            'typeofwork': 'TYPE OF COMPENSATION',
            'workCondition': 'WORKING CONDITION',
            'academico': 'ACADEMIC DEGREE',
            'contratacion': 'CONTRACT TYPE',
            'situacionUS': 'WORK SITUATION US',
            'personal': 'EMPLOYEE TYPE',
            'jornada': 'TYPE OF WORK SCHEDULE',
            'rotacion': 'DOES SHIFT ROTATION',
            'phone': 'COLLABORATOR\'S PHONE',
            'extension': 'DIRECT EXTENSION OF THE COLLABORATOR',
            'cellphone': 'COLLABORATOR\'S CELLPHONE',
            'native': 'NATIVE LANGUAGE',
            'answer': 'ANSWER',
            'other_1': 'OTHERS 1',
            'other_2': 'OTHERS 2',
            'other_3': 'OTHERS 3',
            'other_4': 'OTHERS 4',
            'other_5': 'OTHERS 5',
            'other_6': 'OTHERS 6',
            'other_7': 'OTHERS 7',
            'other_8': 'OTHERS 8',
            'other_9': 'OTHERS 9',
            'other_10': 'OTHERS 10',
          },
        },
    }

    }
  }
};
